export const routes = {
  REGISTER: "/auth/signup",
  LOGIN: "/auth/signin",
  PAYMENT: "/auth/pay",
};
